import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorAccessory from '../../../domain/entities/ActorAccessory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorAccessoriesSuccess: {
      const result = action.payload as PaginatedResult<ActorAccessory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
